module.exports = __webpack_public_path__ + "img/bronze-medal.a3395229.png";